/* eslint-disable react/react-in-jsx-scope */
import { Box, Popover, useMantineColorScheme } from '@mantine/core';

const NewCustomPopover = ({
  opened,
  onChange,
  width = 300,
  position = 'bottom-start',
  shadow = 'md',
  target,
  dropdown,
  dropdownClassName = '',
}) => {
  const { colorScheme } = useMantineColorScheme();
  return (
    <div className="w-[100%]">
      <Box>
        <Popover
          opened={opened}
          onChange={onChange}
          width={width}
          position={position}
          shadow={shadow}
          withinPortal
          styles={{
            dropdown: {
              border: `1px solid ${colorScheme === 'dark' ? '#737373' : '#E8E8E8'}`,
              backgroundColor: colorScheme === 'dark' ? '#1A1B1E' : '#fff',
            },
          }}
        >
          <Popover.Target>{target}</Popover.Target>
          <Popover.Dropdown className={dropdownClassName}>
            {dropdown}
          </Popover.Dropdown>
        </Popover>
      </Box>
    </div>
  );
};

export default NewCustomPopover;
